import _ from 'lodash';
import { NextSeo } from 'next-seo';
import React from 'react';

import { SiteContext } from '@/globals/contexts';
import { withContext } from '@/utils/HOC';
import { getApiUrl } from '@/utils/config';

import ComponentBase from '@/PUFComponents/ComponentBase';
import RawComponent from '@/PUFComponents/RawComponent';

class ForgotPassPage extends ComponentBase {
  static async getInitialProps(ctx) {
    return {};
  }

  render() {
    let bgImage = _.get(this.props, 'siteContext.siteConfig.options.bgImage');

    return (
      <div
        className="Page ForgotPass"
        style={{
          backgroundImage: bgImage && 'url("' + getApiUrl() + bgImage + '")',
        }}
      >
        <NextSeo title="Mot de passe oublié" />

        <div className="Page-body">
          <div className="siteWrapper">
            <RawComponent id="ForgotPass" />
          </div>
        </div>
      </div>
    );
  }
}

export default withContext(SiteContext, 'siteContext', ForgotPassPage);
